@if (websiteUrl() !== null) {
  <app-ui-button
    (click)="openCpruContact()"
    [color]="'tertiary'"
    [disabled]="false"
    [eventAction]="
                  eventActionEnum.HSA_CTA_WEBSITE
                "
    [eventCategory]="eventCategoryEnum.HSA_CTA"
    [eventLabel]="id().toString()"
    [eventParams]="customGa4Params()"
    [expanded]="'block'"
    [size]="'md'"
    appGtmEvent
    appGtmGa4Event
    class="w-full grow"
  >
    <app-ui-icon name="website"></app-ui-icon>
    Hemsida
  </app-ui-button>
}

@if (phoneNumbers() && phoneNumbers().length > 0) {
  <app-ui-button
    (click)="openCpruContact()"
    [color]="'tertiary'"
    [disabled]="false"
    [eventAction]="
                  eventActionEnum.HSA_CTA_PHONE
                "
    [eventCategory]="eventCategoryEnum.HSA_CTA"
    [eventLabel]="id().toString()"
    [eventParams]="eventParams()"
    [expanded]="'block'"
    [size]="'md'"
    appGtmEvent
    appGtmGa4Event
    class="w-full grow"
  >
    <app-ui-icon name="phone"></app-ui-icon>
    Telefon
  </app-ui-button>
}

